import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import '../formFields/fields.scss'
import { connect } from 'react-redux'
import { getSelf } from '../auth/auth.Dux'
import Select from 'react-select-legacy'
import Consultations from '@services/Consultations'

class SelectI18nLanguage extends Component {
  updateLang = (lang) => {
    const { self, i18n } = this.props
    if (!self.profile) return i18n.changeLanguage(lang)
    Consultations.auth
      .updateLanguage({ admin_hash: self.profile.hash, language_code: lang })
      .then(() => i18n.changeLanguage(lang))
      .catch((e) => console.log(e))
  }

  getLang = () => {
    const { language } = this.props.i18n
    return this.languages.find((lang) => lang.value === language)
  }
  onChange = (e) => this.updateLang(e.value)
  languages = [
    { value: 'es', label: 'Español' },
    { value: 'en', label: 'English' },
    { value: 'pt', label: 'Português' },
  ]

  render() {
    const value = this.getLang()
    return (
      <div className="language-selector">
        <Select value={value} options={this.languages} onChange={this.onChange} searchable={false} clearable={false} />
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  self: getSelf(state),
})
export default withTranslation()(connect(mapStateToProps)(SelectI18nLanguage))
